
export enum AppRoutes {
    MAIN = 'main',

}

export enum ChildAppRoutes {
    MAIN_PAGE = 'MAIN_PAGE',

}

export const getRouteMainPage = () => '/main'



